import * as React from "react";
import * as LanguageTexts from "@genesys/shared/lib/language-texts";

// tslint:disable-next-line:variable-name
export const TranslateContext = React.createContext<LanguageTexts.Translate>(
  () => "default translation"
);
